import { render } from "./ConfigTextInput.vue?vue&type=template&id=4150f1b6&ts=true"
import script from "./ConfigTextInput.vue?vue&type=script&lang=ts"
export * from "./ConfigTextInput.vue?vue&type=script&lang=ts"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__